<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.999 31.998">
        <path d="M16.41 0c-.25 0-.487.1-.663.275l-14.74 14.74a3.449 3.449 0 000 4.872l11.106 11.105a3.417 3.417 0 002.435 1.006c.922 0 1.787-.356 2.436-1.006l14.74-14.74a.94.94 0 00.275-.664V3.443A3.449 3.449 0 0028.554 0zm.388 1.875h11.756c.865 0 1.57.703 1.57 1.568V15.2L15.658 29.666a1.556 1.556 0 01-1.11.457c-.421 0-.815-.162-1.11-.457L2.332 18.561a1.57 1.57 0 010-2.22zm6.938 3.441c-.787 0-1.526.308-2.082.864a2.924 2.924 0 00-.864 2.082c0 .788.307 1.526.864 2.084a2.927 2.927 0 002.082.863c.786 0 1.527-.307 2.084-.863a2.927 2.927 0 00.861-2.084c0-.787-.305-1.526-.861-2.082a2.93 2.93 0 00-2.084-.864zm0 1.875c.285 0 .555.112.757.315.203.201.313.47.313.756 0 .286-.11.556-.313.758a1.065 1.065 0 01-.757.314c-.286 0-.556-.112-.758-.314a1.06 1.06 0 01-.313-.758c0-.286.11-.555.313-.756.202-.203.472-.315.758-.315z"/>
    </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
